<template>
  <div class="carousel">
    <div
      v-for="item in items"
      :key="item.id"
      class="carousel-item"
      :class="getItemSizeClass(item.orientation)"
    >
      <NavigationBanner
        :images="item.images"
        :text="item.text"
        :url="item.url"
        :theme="item.theme"
        :orientation="item.orientation"
        :align-image-bottom-desktop="item.alignImageBottomDesktop === true"
        cover
      />
    </div>
  </div>
</template>

<script>
import NavigationBanner from "@/components/navigation/NavigationBanner.vue";

export default {
  name: "NavigationCarousel",
  components: {
    NavigationBanner,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    getItemSizeClass(orientation) {
      // Use the orientation parameter directly
      if (orientation === "landscape") {
        return "carousel-item--landscape";
      }

      // Default to portrait if not specified or if explicitly portrait
      return "carousel-item--portrait";
    },
  },
};
</script>

<style scoped>
.carousel {
  display: flex;
  overflow-x: auto;
  gap: 20px;
  border-left: 1px solid #ccc;
  padding-left: 20px;
  margin-right: -50vw;
  padding-right: 50vw;
  padding-bottom: 10px; /* to ensure content is not cut off by scroll bar */
}

.carousel-item {
  flex: 0 0 40%;
  min-width: 0; /* Ensures flex items can shrink properly */
}

/* Portrait images get 40% width */
.carousel-item--portrait {
  flex: 0 0 310px;
  width: 310px;
}

/* Landscape images */
.carousel-item--landscape {
  flex: 0 0 552px;
  width: 552px;
}
</style>
